import { connect } from 'react-redux';

import { hideLoading, showLoading } from 'store/actions/Global';
import TourOverview from './TourOverview';

const mapStateToProps = (state) => {
    const {
        Global: { windowWidth },
    } = state;

    return { windowWidth };
};

const mapDispatchToProps = (dispatch) => ({
    hideLoading: () => hideLoading()(dispatch),
    showLoading: () => showLoading()(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TourOverview);
